var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 8.25V14.25H14.0625V8.25H6.5625ZM12.1875 12.75H8.4375V9.75H12.1875V12.75ZM6.5625 15.75V21.75H14.0625V15.75H6.5625ZM12.1875 20.25H8.4375V17.25H12.1875V20.25ZM15.9375 8.25V14.25H23.4375V8.25H15.9375ZM21.5625 12.75H17.8125V9.75H21.5625V12.75ZM15.9375 15.75V21.75H23.4375V15.75H15.9375ZM21.5625 20.25H17.8125V17.25H21.5625V20.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.8b44c32d4c7c0c1bd5229077a80f9c03.svg";
export { ForwardRef as ReactComponent };